module.exports = __webpack_public_path__ + "img/podopediatrie.5c693e66.jpg";